import { Link } from "react-router-dom";
import { routesMap } from "@/components/routes/routes";
import OpticksButton from "@/components/ui/OpticksButton/OpticksButton";
import OpticksInput from "@/components/ui/OpticksInput/OpticksInput";
import type { ResetPasswordFormPayload } from "@/types/model/Auth";
import { Controller, useForm } from "react-hook-form";
import { doResetPassword } from "@/services/service-layer/authService";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

interface FormValues {
  newPassword: string;
  confirmPassword: string;
  email: string;
}

const ResetPassword = () => {
  const doResetPasswordFunction = (values: FormValues) => {
    const params = new URLSearchParams(location.search);

    const payload: ResetPasswordFormPayload = {
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
      email: params.get("email") || "",
      hash: params.get("hash") || "",
    };
    doResetPassword(payload);
  };

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({
    mode: "onSubmit",
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
  });

  const newPassword = watch("newPassword");

  return (
    <>
      <OpticksLogo />
      <h2>Reset Password</h2>
      <form
        className="auth-form"
        noValidate={true}
        onSubmit={handleSubmit(doResetPasswordFunction)}
      >
        <div className="fields">
          <Controller
            name="newPassword"
            control={control}
            rules={{
              required: "Please write your new password",
              minLength: {
                value: 6,
                message: "Password must be 6 at least characters length",
              },
            }}
            render={({ field }) => (
              <div>
                <OpticksInput
                  placeholder="New password"
                  type="password"
                  required
                  surface="white"
                  input={field}
                />
                {errors.newPassword && (
                  <span className="form-invalid-message">
                    {errors.newPassword.message}
                  </span>
                )}
              </div>
            )}
          />

          <Controller
            name="confirmPassword"
            control={control}
            rules={{
              required: "Please write your confirmation password",
              validate: (value) =>
                value === newPassword || "Passwords must match",
            }}
            render={({ field }) => (
              <div>
                <OpticksInput
                  placeholder="Repeat new password"
                  type="password"
                  required
                  surface="white"
                  input={field}
                />
                {errors.confirmPassword && (
                  <span className="form-invalid-message">
                    {errors.confirmPassword.message}
                  </span>
                )}
              </div>
            )}
          />
        </div>

        <div className="login-btn">
          <OpticksButton
            type="submit"
            size="m-wide"
            disabled={isSubmitting}
            label="Set new password"
          />
        </div>

        <div className="create-account">
          <span>
            Already have an account?{" "}
            <Link to={routesMap.auth.login.path}>Login</Link>
          </span>
        </div>
      </form>
    </>
  );
};

export default ResetPassword;
